import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/df204f2d-1da5-4f75-9304-ac5a2ae86a41.jpg'
import { useIntl } from 'react-intl';

const TravBusinessAboutUsHistoryTravelPage: React.FC = () => {
  const intl = useIntl();

  const tocItems: ITableOfContentItem[] = [
    {
      id: 'the-travcoding-roots',
      title: intl.formatMessage({ id: 'aboutUs.theTravcodingRoots.title' }),
    },
    {
      id: 'identifying-a-gap',
      title: intl.formatMessage({ id: 'aboutUs.identifyingAGap.title' }),
    },
    {
      id: 'the-birth-of-travbusiness',
      title: intl.formatMessage({ id: 'aboutUs.theBirthOfTravBusiness.title' }),
    },
    {
      id: 'staying-true-to-our-roots',
      title: intl.formatMessage({ id: 'aboutUs.stayingTrueToOurRoots.title' }),
    },
  ];
  
const sections: IContentSection[] = [
    {
      id: 'the-travcoding-roots',
      title: intl.formatMessage({ id: 'aboutUs.theTravcodingRoots.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'aboutUs.theTravcodingRoots.para1' }),
        intl.formatMessage({ id: 'aboutUs.theTravcodingRoots.para2' }),
      ],
    },
    {
      id: 'identifying-a-gap',
      title: intl.formatMessage({ id: 'aboutUs.identifyingAGap.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'aboutUs.identifyingAGap.para1' }),
        intl.formatMessage({ id: 'aboutUs.identifyingAGap.para2' }),
      ],
    },
    {
      id: 'the-birth-of-travbusiness',
      title: intl.formatMessage({ id: 'aboutUs.theBirthOfTravBusiness.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'aboutUs.theBirthOfTravBusiness.para1' }),
        intl.formatMessage({ id: 'aboutUs.theBirthOfTravBusiness.para2' }),
      ],
    },
    {
      id: 'staying-true-to-our-roots',
      title: intl.formatMessage({ id: 'aboutUs.stayingTrueToOurRoots.title' }),
      paragraphs: [
        intl.formatMessage({ id: 'aboutUs.stayingTrueToOurRoots.para1' }),
        intl.formatMessage({ id: 'aboutUs.stayingTrueToOurRoots.para2' }),
        intl.formatMessage({ id: 'aboutUs.stayingTrueToOurRoots.para3' }),
      ],
    },
  ];

  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'aboutUs.headerTitle' })}
        headerSubtitle={intl.formatMessage({ id: 'aboutUs.headerSubtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='top'
      />
    </div>
  );
};

export default TravBusinessAboutUsHistoryTravelPage;
